import { forwardRef, Heading, HeadingProps } from '@chakra-ui/react';

export const H6 = forwardRef<HeadingProps, 'h6'>((props, ref) => {
    return <Heading as="h6" size="h6" ref={ref} {...props} />;
});
